import CRUD from './genericCRUD'

const route = 'regions'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function regions(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),

		/**
		 * @param {number} pageNumber
		 * @param {number} pageSize
		 * @param {string} name
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllFiltered: (pageNumber, pageSize, name, config = {}) => {
			const params =
				!!pageNumber && !!pageSize
					? `pageNumber=${pageNumber}&pageSize=${pageSize}&`
					: ''
			const nameParam = name ? `name=${name}&` : ''

			return instance.get(`${route}?${params}${nameParam}`, config)
		},

		/**
		 * @param {{ regionIds: array }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getFarmsByRegions: (body, config = {}) => {
			return instance.post(`${route}/farms`, body, config)
		}
	}
}
